module.exports = __webpack_public_path__ + "static/Image22@2x-a88b0375170967ba40cd30b3eb9e1224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image22@2x.jpg
// module id = 915
// module chunks = 227233210825294 244429959259914